<template>
  <div class="admin-alumnos-container">
    <CardPrime class="admin-alumnos-card">
      <template #title>
        <div class="card-header">
          <h3 class="card-title">Administración de Alumnos</h3>
        </div>
      </template>
      <template #content>
        <UserTable
          :usuarios="usuarios"
          :rows="lazyParams.rows"
          :totalRecords="totalRecords"
          :filters="filters"
          :loading="loading"
          :permitirListarTodoColegio="true"
          :mostrarColumnaCurso="true"
          @page="onPage"
          @update:filters="updateFilters"
          @editarUsuario="abrirEditarUsuario"
          @clonarUsuario="abrirDialogoClonar"
          @modificarCurso="abrirModificarCurso"
          @agregarAdicionales="abrirAgregarAdicionales"
          @asignarAsignaturas="abrirModalAsignaturasIndividual"
          v-model:selectedUsuarios="selectedUsuarios"
        />
        <div v-if="selectedUsuarios.length > 0" class="mt-4">
          <!-- Sección para actualización masiva de principal y casa -->
          <div class="form-field">
            <label for="curso-principal-select" class="block text-sm font-medium text-gray-700">Curso Principal</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona el Curso Principal'"
              :error="errors.nuevoCursoPrincipal"
              :modelValue="nuevoCursoPrincipal"
              @update:modelValue="nuevoCursoPrincipal = $event"
            />
            <small v-if="mostrarErrores && errors.nuevoCursoPrincipal" class="p-error">{{ errors.nuevoCursoPrincipal }}</small>
          </div>
          <div class="form-field">
            <label for="casa-select" class="block text-sm font-medium text-gray-700">Casa</label>
            <CursoCasaDropDown
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona la Casa'"
              :error="errors.nuevoCasa"
              :modelValue="nuevoCasa"
              @update:modelValue="nuevoCasa = $event"
            />
            <small v-if="mostrarErrores && errors.nuevoCasa" class="p-error">{{ errors.nuevoCasa }}</small>
          </div>
          <div class="form-field">
            <label for="cursos-adicionales-select" class="block text-sm font-medium text-gray-700">Cursos Adicionales</label>
            <CursoDropdown
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona los Cursos Adicionales'"
              :error="errors.nuevosCursosAdicionales"
              :modelValue="nuevosCursosAdicionales"
              @update:modelValue="nuevosCursosAdicionales = $event"
            />
            <small v-if="mostrarErrores && errors.nuevosCursosAdicionales" class="p-error">{{ errors.nuevosCursosAdicionales }}</small>
          </div>
          <ButtonPrime
            label="Actualizar Cursos Seleccionados"
            @click="openConfirmModal"
            class="mt-2"
          />
          <!-- Sección para agregar cursos adicionales -->
          <div class="form-field mt-4">
            <label for="cursos-adicionales-agregar" class="block text-sm font-medium text-gray-700">Agregar Cursos Adicionales</label>
            <CursoDropdown
              :mostrarErrores="mostrarErroresAdicionales"
              :tooltip="'Selecciona los Cursos Adicionales a agregar'"
              :error="errorsAdicionales.nuevosCursosAdicionales"
              :modelValue="nuevosCursosAdicionales"
              @update:modelValue="nuevosCursosAdicionales = $event"
            />
            <small v-if="mostrarErroresAdicionales && errorsAdicionales.nuevosCursosAdicionales" class="p-error">{{ errorsAdicionales.nuevosCursosAdicionales }}</small>
          </div>
          <ButtonPrime
            label="Agregar Cursos Adicionales Seleccionados"
            @click="openConfirmModalAdicionales"
            class="mt-2"
          />
          <div class="form-field mt-6 border-t pt-4">
            <h4 class="text-sm font-semibold text-gray-800 mb-1">Asignaturas al contrato (detalle)</h4>
            <p class="text-xs text-gray-600 mb-3">
              Elige el curso del ítem en el contrato y las asignaturas a registrar en el detalle del contrato vigente.
            </p>
            <label class="block text-sm font-medium text-gray-700 mb-1">Curso en contrato / detalle</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErroresAsignaturas"
              :tooltip="'Curso del ítem de contrato'"
              :error="errorsAsignaturas.cursoContrato"
              :modelValue="cursoContratoAsignaturaMasivo"
              @update:modelValue="cursoContratoAsignaturaMasivo = $event"
            />
            <small v-if="mostrarErroresAsignaturas && errorsAsignaturas.cursoContrato" class="p-error">{{ errorsAsignaturas.cursoContrato }}</small>
          </div>
          <div class="form-field">
            <label class="block text-sm font-medium text-gray-700">Asignaturas a agregar</label>
            <AsignaturaDropdown
              :mostrarErrores="mostrarErroresAsignaturas"
              :tooltip="'Selecciona una o más asignaturas'"
              :error="errorsAsignaturas.asignaturas"
              :modelValue="asignaturasMasivo"
              @update:modelValue="asignaturasMasivo = $event"
            />
            <small v-if="mostrarErroresAsignaturas && errorsAsignaturas.asignaturas" class="p-error">{{ errorsAsignaturas.asignaturas }}</small>
          </div>
          <ButtonPrime
            label="Asignar asignaturas a seleccionados"
            icon="pi pi-list"
            @click="openConfirmModalAsignaturasMasivo"
            class="mt-2"
          />
        </div>
        <!-- Modal para actualización masiva -->
        <DialogPrime
          header="Confirmar Actualización de Cursos"
          v-model:visible="showConfirmModal"
          :modal="true"
          :closable="false"
        >
          <p>
            ¿Estás seguro de actualizar los cursos de {{ selectedUsuarios.length }} alumno(s) con el curso principal, casa y cursos adicionales seleccionados?
          </p>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarActualizacionMasiva" />
            <ButtonPrime label="Cancelar" @click="closeConfirmModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal para agregar cursos adicionales masivos -->
        <DialogPrime
          header="Confirmar Agregar Cursos Adicionales"
          v-model:visible="showConfirmModalAdicionales"
          :modal="true"
          :closable="false"
        >
          <p>
            ¿Estás seguro de agregar {{ nuevosCursosAdicionales.length }} cursos adicionales a {{ selectedUsuarios.length }} alumno(s)?
          </p>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarAgregarAdicionales" />
            <ButtonPrime label="Cancelar" @click="closeConfirmModalAdicionales" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <DialogPrime
          header="Confirmar asignación de asignaturas"
          v-model:visible="showConfirmModalAsignaturasMasivo"
          :modal="true"
          :closable="false"
        >
          <p>
            Se agregarán {{ asignaturasMasivo.length }} asignatura(s) al contrato vigente de
            {{ selectedUsuarios.length }} alumno(s), con el curso de detalle seleccionado.
          </p>
          <div class="flex justify-end space-x-2 mt-3">
            <ButtonPrime label="Confirmar" @click="confirmarAsignaturasMasivo" />
            <ButtonPrime label="Cancelar" @click="closeConfirmModalAsignaturasMasivo" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <DialogPrime
          header="Progreso"
          v-model:visible="showProgressModalAsignaturas"
          :modal="true"
          :closable="false"
        >
          <p>Procesando {{ currentProgressAsignaturas }} de {{ totalProgressAsignaturas }}…</p>
          <ProgressBar :value="progressAsignaturasPct" />
        </DialogPrime>
        <DialogPrime
          header="Asignaturas al contrato (detalle)"
          v-model:visible="showAsignaturasIndividualModal"
          :modal="true"
          :closable="false"
        >
          <p v-if="usuarioAsignaturas" class="text-sm text-gray-700 mb-3">
            {{ usuarioAsignaturas.Nombre }} {{ usuarioAsignaturas.ApellidoPaterno }}
            <span v-if="usuarioAsignaturas.curso_nombre" class="text-gray-500"> — {{ usuarioAsignaturas.curso_nombre }}</span>
          </p>
          <div class="form-field">
            <label class="block text-sm font-medium text-gray-700">Curso en contrato / detalle</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErroresAsignaturasInd"
              :tooltip="'Curso del ítem de contrato'"
              :error="errorsAsignaturasInd.cursoContrato"
              :modelValue="cursoContratoAsignaturaIndividual"
              @update:modelValue="cursoContratoAsignaturaIndividual = $event"
            />
            <small v-if="mostrarErroresAsignaturasInd && errorsAsignaturasInd.cursoContrato" class="p-error">{{ errorsAsignaturasInd.cursoContrato }}</small>
          </div>
          <div class="form-field">
            <label class="block text-sm font-medium text-gray-700">Asignaturas a agregar</label>
            <AsignaturaDropdown
              :mostrarErrores="mostrarErroresAsignaturasInd"
              :tooltip="'Selecciona una o más asignaturas'"
              :error="errorsAsignaturasInd.asignaturas"
              :modelValue="asignaturasIndividual"
              @update:modelValue="asignaturasIndividual = $event"
            />
            <small v-if="mostrarErroresAsignaturasInd && errorsAsignaturasInd.asignaturas" class="p-error">{{ errorsAsignaturasInd.asignaturas }}</small>
          </div>
          <div class="flex justify-end space-x-2 mt-3">
            <ButtonPrime label="Confirmar" @click="confirmarAsignaturasIndividual" />
            <ButtonPrime label="Cancelar" @click="closeAsignaturasIndividualModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal para modificar curso individual -->
        <DialogPrime
          header="Modificar Curso de Alumno"
          v-model:visible="showModificarCursoModal"
          :modal="true"
          :closable="false"
        >
          <div class="form-field">
            <label for="curso-principal-individual" class="block text-sm font-medium text-gray-700">Curso Principal</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona el Curso Principal'"
              :error="errors.cursoPrincipalIndividual"
              :modelValue="cursoPrincipalIndividual"
              @update:modelValue="cursoPrincipalIndividual = $event"
            />
            <small v-if="mostrarErrores && errors.cursoPrincipalIndividual" class="p-error">{{ errors.cursoPrincipalIndividual }}</small>
          </div>
          <div class="form-field">
            <label for="casa-individual" class="block text-sm font-medium text-gray-700">Casa</label>
            <CursoCasaDropDown
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona la Casa'"
              :error="errors.casaIndividual"
              :modelValue="casaIndividual"
              @update:modelValue="casaIndividual = $event"
            />
            <small v-if="mostrarErrores && errors.casaIndividual" class="p-error">{{ errors.casaIndividual }}</small>
          </div>
          <div class="form-field">
            <label for="cursos-adicionales-individual" class="block text-sm font-medium text-gray-700">Cursos Adicionales</label>
            <CursoDropdown
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona los Cursos Adicionales'"
              :error="errors.cursosAdicionalesIndividual"
              :modelValue="cursosAdicionalesIndividual"
              @update:modelValue="cursosAdicionalesIndividual = $event"
            />
            <small v-if="mostrarErrores && errors.cursosAdicionalesIndividual" class="p-error">{{ errors.cursosAdicionalesIndividual }}</small>
          </div>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarActualizacionIndividual" />
            <ButtonPrime label="Cancelar" @click="closeModificarCursoModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal para agregar cursos adicionales individual -->
        <DialogPrime
          header="Agregar Cursos Adicionales a Alumno"
          v-model:visible="showAgregarAdicionalesModal"
          :modal="true"
          :closable="false"
        >
          <div class="form-field">
            <label for="cursos-adicionales-individual" class="block text-sm font-medium text-gray-700">Cursos Adicionales a Agregar</label>
            <CursoDropdown
              :mostrarErrores="mostrarErroresAdicionales"
              :tooltip="'Selecciona los Cursos Adicionales a agregar'"
              :error="errorsAdicionales.cursosAdicionalesIndividual"
              :modelValue="cursosAdicionalesIndividual"
              @update:modelValue="cursosAdicionalesIndividual = $event"
            />
            <small v-if="mostrarErroresAdicionales && errorsAdicionales.cursosAdicionalesIndividual" class="p-error">{{ errorsAdicionales.cursosAdicionalesIndividual }}</small>
          </div>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarAgregarAdicionalesIndividual" />
            <ButtonPrime label="Cancelar" @click="closeAgregarAdicionalesModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <UserDialog
          :visible="usuarioDialog"
          :usuario="usuario"
          :perfiles="perfiles"
          :cerrarDialog="cerrarDialog"
          :guardarUsuario="guardarUsuario"
        />
        <DialogPrime
          v-model:visible="clonarDialogVisible"
          header="Selecciona los cursos para el nuevo usuario"
          :modal="true"
          :style="{ width: '50vw' }"
        >
          <ul>
            <li v-for="curso in cursos" :key="curso.curso_id">
              <CheckboxPrime v-model="cursosSeleccionados" :value="curso.curso_id" :binary="false"></CheckboxPrime>
              <strong>{{ curso.curso }}</strong>
              <ul>
                <li v-for="asignatura in curso.asignaturas" :key="asignatura.asignatura_id">
                  {{ asignatura.asignatura }}
                </li>
              </ul>
            </li>
          </ul>
          <template #footer>
            <ButtonPrime label="Generar Alumno" @click="generarNuevoAlumno('alumno')" />
            <ButtonPrime label="Generar Docente" @click="generarNuevoAlumno('docente')" />
            <ButtonPrime label="Cancelar" @click="cerrarDialogoClonar" />
          </template>
        </DialogPrime>
        <ContratoUsuarioDialog
          v-model:visible="editarContratoDialogVisible"
          :usuarioId="usuarioSeleccionado"
          @contrato-actualizado="actualizarListaUsuarios"
        />
        <ToastPrime />
      </template>
    </CardPrime>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import usuarioService from '@/services/UsuarioService';
import CardPrime from 'primevue/card';
import ButtonPrime from 'primevue/button';
import DialogPrime from 'primevue/dialog';
import ToastPrime from 'primevue/toast';
import CheckboxPrime from 'primevue/checkbox';
import UserTable from '@/components/user/UserTable.vue';
import UserDialog from '@/components/user/UserDialog.vue';
import ContratoUsuarioDialog from '@/components/user/ContratoUsuarioDialog.vue';
import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue';
import SingleCursoCombo from '@/components/selectores/SingleCursoCombo.vue';
import CursoCasaDropDown from '@/components/selectores/CursoCasaDropDown.vue';
import CursoDropdown from '@/components/selectores/CursoDropdown.vue';
import axios from 'axios';

export default {
  components: {
    CardPrime,
    ButtonPrime,
    DialogPrime,
    ToastPrime,
    CheckboxPrime,
    UserTable,
    UserDialog,
    ContratoUsuarioDialog,
    AsignaturaDropdown,
    SingleCursoCombo,
    CursoCasaDropDown,
    CursoDropdown
  },
  data() {
    return {
      usuario_clonar: null,
      usuarios: [],
      usuario: {},
      usuarioDialog: false,
      clonarDialogVisible: false,
      cursos: [],
      totalRecords: 0,
      loading: false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        colegio: '',
        curso: ''
      },
      lazyParams: {
        first: 0,
        rows: 20,
        page: 1
      },
      perfiles: [
        { Id: 1, Glosa: 'Docente' },
        { Id: 2, Glosa: 'Alumno' }
      ],
      cursosSeleccionados: [],
      editarContratoDialogVisible: false,
      usuarioSeleccionado: null,
      selectedUsuarios: [],
      nuevoCursoPrincipal: '',
      nuevoCasa: '',
      nuevosCursosAdicionales: [],
      showConfirmModal: false,
      showConfirmModalAdicionales: false,
      showModificarCursoModal: false,
      showAgregarAdicionalesModal: false,
      cursoPrincipalIndividual: '',
      casaIndividual: '',
      cursosAdicionalesIndividual: [],
      errors: {
        nuevoCursoPrincipal: '',
        nuevoCasa: '',
        nuevosCursosAdicionales: '',
        cursoPrincipalIndividual: '',
        casaIndividual: '',
        cursosAdicionalesIndividual: ''
      },
      errorsAdicionales: {
        nuevosCursosAdicionales: '',
        cursosAdicionalesIndividual: ''
      },
      mostrarErrores: false,
      mostrarErroresAdicionales: false,
      usuarioModificar: null,
      cursoContratoAsignaturaMasivo: '',
      asignaturasMasivo: [],
      showConfirmModalAsignaturasMasivo: false,
      showProgressModalAsignaturas: false,
      currentProgressAsignaturas: 0,
      totalProgressAsignaturas: 0,
      errorsAsignaturas: {
        cursoContrato: '',
        asignaturas: ''
      },
      mostrarErroresAsignaturas: false,
      showAsignaturasIndividualModal: false,
      usuarioAsignaturas: null,
      cursoContratoAsignaturaIndividual: '',
      asignaturasIndividual: [],
      errorsAsignaturasInd: {
        cursoContrato: '',
        asignaturas: ''
      },
      mostrarErroresAsignaturasInd: false
    };
  },
  computed: {
    progressAsignaturasPct() {
      if (!this.totalProgressAsignaturas) return 0;
      return Math.round((100 * this.currentProgressAsignaturas) / this.totalProgressAsignaturas);
    }
  },
  methods: {
    parseCursoId(val) {
      if (val === null || val === undefined || val === '') return null;
      if (Array.isArray(val)) {
        const x = val[0];
        if (x === null || x === undefined || x === '') return null;
        return parseInt(x, 10);
      }
      return parseInt(val, 10);
    },
    normalizeColegioFiltro(v) {
      const n = parseInt(v, 10);
      return Number.isNaN(n) ? 0 : n;
    },
    normalizeCursoFiltro(val) {
      if (val === 0 || val === '0') return 0;
      const n = this.parseCursoId(val);
      return n == null || Number.isNaN(n) ? 0 : n;
    },
    payloadAsignaturaContrato(idUsuario, idCurso, idAsignatura) {
      return {
        IdUsuario: idUsuario,
        IdCurso: idCurso,
        IdAsignatura: idAsignatura,
        ValorNeto: 100000,
        PorcentajeIVA: 19,
        CantidadLicencias: 1,
        Vigente: true,
        IdUsuarioCreacion: 1,
        IdUsuarioActualizacion: 1
      };
    },
    async cargarUsuarios() {
      this.loading = true;
      try {
        const response = await usuarioService.getAlumnosPorCurso({
          IdColegio: this.normalizeColegioFiltro(this.filters.colegio),
          IdCurso: this.normalizeCursoFiltro(this.filters.curso),
          Page: this.lazyParams.page,
          Rows: this.lazyParams.rows
        });
        this.usuarios = response.data.items.map(usuario => ({
          ...usuario,
          Nombre: usuario.nombre,
          ApellidoPaterno: usuario.apellido_paterno,
          ApellidoMaterno: usuario.apellido_materno,
          IdentificadorRut: usuario.identificador_rut,
          Email: usuario.email,
          NombreCompleto: `${usuario.nombre} ${usuario.apellido_paterno}`
        }));
        this.totalRecords = response.data.totalRecords;
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
      } finally {
        this.loading = false;
      }
    },
    updateFilters(newFilters) {
      this.filters = {
        ...this.filters,
        colegio: newFilters.colegio,
        curso: newFilters.curso
      };
      this.lazyParams.page = 1;
      this.lazyParams.first = 0;
      this.cargarUsuarios();
    },
    onPage(event) {
      this.lazyParams = {
        ...this.lazyParams,
        first: event.first,
        rows: event.rows,
        page: Math.floor(event.first / event.rows) + 1
      };
      this.cargarUsuarios();
    },
    abrirDialogoClonar(usuario) {
      this.usuario_clonar = usuario.id_usuario;
      this.clonarDialogVisible = true;
      this.obtenerCursos(usuario.id_usuario);
    },
    async obtenerCursos(usuarioId) {
      try {
        const response = await usuarioService.getCursosPorUsuario(usuarioId);
        this.cursos = this.agruparCursosYAsignaturas(response.data);
      } catch (error) {
        console.error('Error al obtener cursos:', error);
      }
    },
    agruparCursosYAsignaturas(cursos) {
      const agrupados = {};
      cursos.forEach(item => {
        const { id_curso, id_asignatura, curso: nombreCurso, asignatura: nombreAsignatura } = item;
        if (!agrupados[id_curso]) {
          agrupados[id_curso] = {
            curso_id: id_curso,
            curso: nombreCurso,
            asignaturas: []
          };
        }
        agrupados[id_curso].asignaturas.push({
          asignatura_id: id_asignatura,
          asignatura: nombreAsignatura
        });
      });
      return Object.values(agrupados);
    },
    generarNuevoAlumno(tipo) {
      if (this.cursosSeleccionados.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un curso.',
          life: 3000
        });
        return;
      }
      this.$router.push({
        name: 'admin-alumnos-nuevo',
        params: { id_usuario: this.usuario_clonar },
        query: { cursos: this.cursosSeleccionados.join(','), tipo: tipo }
      });
      this.cerrarDialogoClonar();
    },
    cerrarDialogoClonar() {
      this.clonarDialogVisible = false;
      this.cursosSeleccionados = [];
    },
    abrirEditarUsuario(data) {
      this.usuario = { ...data };
      this.usuarioDialog = true;
    },
    cerrarDialog() {
      this.usuarioDialog = false;
      this.usuario = {};
    },
    async guardarUsuario() {
      try {
        if (this.usuario.Id) {
          await usuarioService.actualizarUsuario(this.usuario.Id, this.usuario);
        } else {
          await usuarioService.crearUsuario(this.usuario);
        }
        this.cerrarDialog();
        this.cargarUsuarios();
      } catch (error) {
        console.error('Error al guardar usuario:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo guardar el usuario.',
          life: 3000
        });
      }
    },
    abrirDialogoEditarContrato(usuario) {
      this.usuarioSeleccionado = usuario.id_usuario;
      this.editarContratoDialogVisible = true;
    },
    actualizarListaUsuarios() {
      this.cargarUsuarios();
    },
    openConfirmModal() {
      this.errors.nuevoCursoPrincipal = !this.nuevoCursoPrincipal ? 'Debes seleccionar un curso principal' : '';
      this.errors.nuevoCasa = !this.nuevoCasa ? 'Debes seleccionar una casa' : '';
      this.errors.nuevosCursosAdicionales = this.nuevosCursosAdicionales.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErrores = true;
      if (this.errors.nuevoCursoPrincipal || this.errors.nuevoCasa || this.errors.nuevosCursosAdicionales) {
        return;
      }
      if (!this.selectedUsuarios.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un alumno.',
          life: 3000
        });
        return;
      }
      this.mostrarErrores = false;
      this.showConfirmModal = true;
    },
    closeConfirmModal() {
      this.showConfirmModal = false;
    },
    async confirmarActualizacionMasiva() {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/cursos-detalle', {
          IdUsuarios: this.selectedUsuarios.map(u => parseFloat(u.id_usuario)),
          IdCursoPrincipal: parseFloat(this.nuevoCursoPrincipal),
          IdCasa: parseFloat(this.nuevoCasa),
          CursosAdicionales: this.nuevosCursosAdicionales.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
        this.selectedUsuarios = [];
        this.nuevoCursoPrincipal = '';
        this.nuevoCasa = '';
        this.nuevosCursosAdicionales = [];
      } catch (error) {
        console.error('Error al actualizar cursos:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeConfirmModal();
      }
    },
    openConfirmModalAdicionales() {
      this.errorsAdicionales.nuevosCursosAdicionales = this.nuevosCursosAdicionales.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErroresAdicionales = true;
      if (this.errorsAdicionales.nuevosCursosAdicionales) {
        return;
      }
      if (!this.selectedUsuarios.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un alumno.',
          life: 3000
        });
        return;
      }
      this.mostrarErroresAdicionales = false;
      this.showConfirmModalAdicionales = true;
    },
    closeConfirmModalAdicionales() {
      this.showConfirmModalAdicionales = false;
    },
    async confirmarAgregarAdicionales() {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/contrato-detalle/agregar-cursos', {
          IdUsuarios: this.selectedUsuarios.map(u => parseFloat(u.id_usuario)),
          CursosAdicionales: this.nuevosCursosAdicionales.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
        this.selectedUsuarios = [];
        this.nuevosCursosAdicionales = [];
      } catch (error) {
        console.error('Error al agregar cursos adicionales:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeConfirmModalAdicionales();
      }
    },
    abrirModificarCurso(usuario) {
      this.usuarioModificar = usuario;
      this.showModificarCursoModal = true;
    },
    closeModificarCursoModal() {
      this.showModificarCursoModal = false;
      this.cursoPrincipalIndividual = '';
      this.casaIndividual = '';
      this.cursosAdicionalesIndividual = [];
      this.usuarioModificar = null;
    },
    async confirmarActualizacionIndividual() {
      this.errors.cursoPrincipalIndividual = !this.cursoPrincipalIndividual ? 'Debes seleccionar un curso principal' : '';
      this.errors.casaIndividual = !this.casaIndividual ? 'Debes seleccionar una casa' : '';
      this.errors.cursosAdicionalesIndividual = this.cursosAdicionalesIndividual.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErrores = true;
      if (this.errors.cursoPrincipalIndividual || this.errors.casaIndividual || this.errors.cursosAdicionalesIndividual) {
        return;
      }
      this.mostrarErrores = false;
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/cursos-detalle', {
          IdUsuarios: [parseFloat(this.usuarioModificar.id_usuario)],
          IdCursoPrincipal: parseFloat(this.cursoPrincipalIndividual),
          IdCasa: parseFloat(this.casaIndividual),
          CursosAdicionales: this.cursosAdicionalesIndividual.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
      } catch (error) {
        console.error('Error al actualizar curso:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeModificarCursoModal();
      }
    },
    abrirAgregarAdicionales(usuario) {
      this.usuarioModificar = usuario;
      this.showAgregarAdicionalesModal = true;
    },
    closeAgregarAdicionalesModal() {
      this.showAgregarAdicionalesModal = false;
      this.cursosAdicionalesIndividual = [];
      this.usuarioModificar = null;
    },
    async confirmarAgregarAdicionalesIndividual() {
      this.errorsAdicionales.cursosAdicionalesIndividual = this.cursosAdicionalesIndividual.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErroresAdicionales = true;
      if (this.errorsAdicionales.cursosAdicionalesIndividual) {
        return;
      }
      this.mostrarErroresAdicionales = false;
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/contrato-detalle/agregar-cursos', {
          IdUsuarios: [parseFloat(this.usuarioModificar.id_usuario)],
          CursosAdicionales: this.cursosAdicionalesIndividual.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
      } catch (error) {
        console.error('Error al agregar cursos adicionales:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeAgregarAdicionalesModal();
      }
    },
    openConfirmModalAsignaturasMasivo() {
      this.errorsAsignaturas.cursoContrato = !this.parseCursoId(this.cursoContratoAsignaturaMasivo)
        ? 'Selecciona el curso del contrato'
        : '';
      this.errorsAsignaturas.asignaturas =
        !this.asignaturasMasivo || this.asignaturasMasivo.length === 0
          ? 'Selecciona al menos una asignatura'
          : '';
      this.mostrarErroresAsignaturas = true;
      if (this.errorsAsignaturas.cursoContrato || this.errorsAsignaturas.asignaturas) {
        return;
      }
      if (!this.selectedUsuarios.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un alumno.',
          life: 3000
        });
        return;
      }
      this.mostrarErroresAsignaturas = false;
      this.showConfirmModalAsignaturasMasivo = true;
    },
    closeConfirmModalAsignaturasMasivo() {
      this.showConfirmModalAsignaturasMasivo = false;
    },
    async confirmarAsignaturasMasivo() {
      this.closeConfirmModalAsignaturasMasivo();
      const idCurso = this.parseCursoId(this.cursoContratoAsignaturaMasivo);
      const idsAsig = (this.asignaturasMasivo || []).map((id) => parseInt(id, 10));
      this.totalProgressAsignaturas = this.selectedUsuarios.length * idsAsig.length;
      this.currentProgressAsignaturas = 0;
      this.showProgressModalAsignaturas = true;
      let errores = 0;
      try {
        for (const u of this.selectedUsuarios) {
          const idUsuario = parseInt(u.id_usuario, 10);
          for (const idAsig of idsAsig) {
            try {
              await usuarioService.agregarAsignaturaAlContrato(
                this.payloadAsignaturaContrato(idUsuario, idCurso, idAsig)
              );
            } catch (e) {
              errores++;
              console.error(e);
            }
            this.currentProgressAsignaturas++;
          }
        }
        this.$toast.add({
          severity: errores ? 'warn' : 'success',
          summary: errores ? 'Finalizado con advertencias' : 'Éxito',
          detail:
            errores > 0
              ? `Operación terminada. No se pudieron aplicar ${errores} combinación(es) alumno/asignatura.`
              : 'Asignaturas agregadas al contrato.',
          life: 5000
        });
        this.cargarUsuarios();
        this.selectedUsuarios = [];
        this.asignaturasMasivo = [];
        this.cursoContratoAsignaturaMasivo = '';
      } finally {
        this.showProgressModalAsignaturas = false;
      }
    },
    abrirModalAsignaturasIndividual(usuario) {
      this.usuarioAsignaturas = usuario;
      this.cursoContratoAsignaturaIndividual = '';
      this.asignaturasIndividual = [];
      this.errorsAsignaturasInd = { cursoContrato: '', asignaturas: '' };
      this.mostrarErroresAsignaturasInd = false;
      this.showAsignaturasIndividualModal = true;
    },
    closeAsignaturasIndividualModal() {
      this.showAsignaturasIndividualModal = false;
      this.usuarioAsignaturas = null;
      this.cursoContratoAsignaturaIndividual = '';
      this.asignaturasIndividual = [];
    },
    async confirmarAsignaturasIndividual() {
      const idCurso = this.parseCursoId(this.cursoContratoAsignaturaIndividual);
      this.errorsAsignaturasInd.cursoContrato = !idCurso ? 'Selecciona el curso del contrato' : '';
      this.errorsAsignaturasInd.asignaturas =
        !this.asignaturasIndividual || this.asignaturasIndividual.length === 0
          ? 'Selecciona al menos una asignatura'
          : '';
      this.mostrarErroresAsignaturasInd = true;
      if (this.errorsAsignaturasInd.cursoContrato || this.errorsAsignaturasInd.asignaturas) {
        return;
      }
      this.mostrarErroresAsignaturasInd = false;
      const idUsuario = parseInt(this.usuarioAsignaturas.id_usuario, 10);
      const idsAsig = this.asignaturasIndividual.map((id) => parseInt(id, 10));
      let errores = 0;
      try {
        for (const idAsig of idsAsig) {
          try {
            await usuarioService.agregarAsignaturaAlContrato(
              this.payloadAsignaturaContrato(idUsuario, idCurso, idAsig)
            );
          } catch (e) {
            errores++;
            console.error(e);
          }
        }
        this.$toast.add({
          severity: errores ? 'warn' : 'success',
          summary: errores ? 'Advertencia' : 'Éxito',
          detail:
            errores > 0
              ? `Algunas asignaturas no se pudieron agregar (${errores}).`
              : 'Asignaturas agregadas al contrato.',
          life: 4000
        });
        this.cargarUsuarios();
        this.closeAsignaturasIndividualModal();
      } catch (e) {
        console.error(e);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo completar la operación.',
          life: 4000
        });
      }
    }
  },
  mounted() {
    this.cargarUsuarios();
  }
};
</script>

<style scoped>
.admin-alumnos-container {
  padding: 1rem;
}
.admin-alumnos-card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.card-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: #1a202c;
}
.form-field {
  margin-bottom: 1rem;
}
.form-field label {
  display: block;
  font-size: 0.875rem;
  font-weight: medium;
  color: #4a5568;
  margin-bottom: 0.25rem;
}
</style>